import { SVGAttributes } from "react";

export const Sage50Logo = ({
  title,
  ...props
}: SVGAttributes<SVGElement> & {
  title?: string;
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 600 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{title}</title>
      <circle cx="300" cy="300" r="300" fill="#00DC00" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M439.79 291.911C439.79 269.918 456.257 259.289 474.013 259.289C491.767 259.289 507.777 270.101 507.777 291.911H439.79ZM470.872 236C434.688 236 411.002 261.125 411.002 302.564C411.002 354.002 447.229 368.759 473.102 368.759C505.877 368.759 524.56 346.465 524.56 346.465L507.889 329.549C499.045 337.589 488.787 342.399 473.513 342.399C453.344 342.399 439.75 330.46 439.75 314.126H529.622C529.622 314.126 545.315 236 470.872 236Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.271 289.694C133.072 288.239 100.624 289.55 100.624 274.189C100.624 265.082 114.223 260.182 126.762 260.182C146.799 260.182 160.005 268.506 163.845 271.271L180.679 253.781C175.695 249.602 157.139 236 126.762 236C99.0847 236 74.1847 251.035 74.1847 275.149C74.1847 312.147 117.154 312.136 135.097 313.958C145.964 315.059 155.888 315.837 155.888 326.907C155.888 337.199 140.711 342.926 128.963 342.926C109.815 342.926 98.3414 336.389 87.1163 325.903L69 344.748C85.6166 361.417 106.667 368.759 127.405 368.759C159.521 368.759 183 354.034 183 324.405C183 304.764 170.293 293.071 144.271 289.694Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.418 319.779C265.418 344.365 248.498 343.041 233.386 343.041C218.091 343.041 208.324 338.824 208.324 327.8C208.324 317.528 216.28 314.123 232.717 314.123H265.418V319.779ZM237.144 236C209.122 236 190.957 250.773 187.578 253.753L204.564 271.343C207.946 268.564 219.473 260.331 237.357 260.331C258.82 260.331 265.226 269.192 265.226 279.215V291.696L226.969 291.72C212.824 291.72 184.999 295.41 184.999 327.648C184.999 351.329 198.115 368.759 229.424 368.759C245.142 368.759 257.026 363.484 265.226 353.311V366.165H292.999V281.121C292.999 251.379 275.388 236 237.144 236Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M380.116 300.286C380.116 309.895 379.954 317.011 379.162 320.633C377.41 328.637 368.11 339.158 351.229 339.158C347.004 339.158 325.35 336.786 322.925 318.437C322.434 314.762 322.062 309.895 322.062 300.286C322.062 285.997 322.663 281.455 323.412 277.825C324.903 270.628 334.524 260.043 351.229 260.043C371.686 260.043 378.256 273.678 379.219 278.948C379.887 282.594 380.116 290.677 380.116 300.286ZM380.116 238.647V252.482C370.409 241.449 358.821 236 342.999 236C315.98 236 302.066 250.824 297.355 266.607C295.606 272.473 295.003 283.675 295.003 300.231C295.003 315.83 295.148 330.016 300.694 340.925C308.448 356.189 327.274 364.714 342.999 364.714C358.236 364.714 371.166 358.936 380.116 348.907V356.653C380.116 365.753 376.928 371.73 370.978 376.454C365.014 381.191 357.533 384.094 347.149 384.094C337.73 384.094 328.703 379.069 323.558 375.571L304.403 394.307C316.821 404.159 331.67 410.868 347.694 410.997C364.674 411.134 378.34 406.102 390.314 396.893C401.775 388.075 409.003 371.498 409.003 353.911V238.647H380.116Z"
        fill="white"
      />
    </svg>
  );
};
